export type MimeTypes =
  | 'application/x-rar-compressed'
  | 'application/octet-stream'
  | 'application/zip'
  | 'application/x-zip-compressed'
  | 'multipart/x-zip'
  | 'image/gif'
  | 'image/jpeg'
  | 'image/png'
  | 'application/x-apple-diskimage'
  | 'video/mpeg'
  | 'video/quicktime'
  | 'video/x-msvideo'
  | 'video/mp4'
  | 'audio/mpeg'
  | 'audio/midi'
  | 'audio/x-midi'
  | 'audio/wav'
  | 'audio/webm'
  | 'application/pdf'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/msword'
  | 'text/csv'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  | 'application/vnd.ms-excel'
  | 'text/plain'
  | 'video/x-flv'
  | 'application/x-mpegURL'
  | 'video/MP2T'
  | 'video/3gpp'
  | 'video/x-ms-wmv'
  | 'application/vnd.apple.mpegurl'
  | 'video/3gpp'
  | 'video/ogg'
  | 'video/webm'
  | 'video/x-m4v'
  | 'video/ms-asf'
  | 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
  | 'application/vnd.ms-excel.sheet.macroEnabled.12'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  | 'image/svg+xml'
  | 'image/webp';
export type FileTypes =
  | 'EXE'
  | 'ZIP'
  | 'DMG'
  | 'VIDEO'
  | 'AUDIO'
  | 'IMAGE'
  | 'RAR'
  | 'PDF'
  | 'WORD'
  | 'CSV'
  | 'TEXT'
  | 'EXCEL'
  | 'PPTX';
export const MIME_TYPES: Record<FileTypes, MimeTypes[]> = {
  IMAGE: [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/webp',
  ],
  RAR: ['application/x-rar-compressed', 'application/octet-stream'],
  ZIP: ['application/zip', 'application/x-zip-compressed', 'multipart/x-zip'],
  EXE: ['application/octet-stream'],
  DMG: ['application/x-apple-diskimage'],
  VIDEO: [
    'video/mpeg',
    'video/quicktime',
    'video/x-msvideo',
    'video/mp4',
    'video/x-flv',
    'video/MP2T',
    'application/x-mpegURL',
    'video/3gpp',
    'video/x-ms-wmv',
    'application/vnd.apple.mpegurl',
    'video/3gpp',
    'video/ogg',
    'video/webm',
    'video/x-m4v',
    'video/ms-asf',
  ],
  AUDIO: [
    'audio/mpeg',
    'audio/midi',
    'audio/x-midi',
    'audio/wav',
    'audio/webm',
  ],
  PDF: ['application/pdf'],
  WORD: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ],
  CSV: ['text/csv'],
  TEXT: ['text/plain'],
  EXCEL: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
  ],
  PPTX: [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
};

// eslint-disable-next-line import/prefer-default-export
export function base64ToBlob(base64: string, mime: string): Blob {
  mime = mime || '';
  const sliceSize = 1024;
  const byteChars = window.atob(base64);
  const byteArrays = [];
  for (
    let offset = 0, len = byteChars.length;
    offset < len;
    offset += sliceSize
  ) {
    const slice = byteChars.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: mime });
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}
export function getFileNameFromPath(path: string): string {
  const array = path.split('/');
  return array.slice(-1)[0];
}
